import { useId, useState, type ReactElement } from 'react';

import { useDebouncedValue } from '@/lib/use-debounced-value';

import type { Position } from '../types';
import { usePositionSearch } from '../use-responsibilities';

// Búsqueda de un puesto del catálogo del LMS para asignarlo como responsable. Filtra
// mientras se escribe (el catálogo es corto y está en caché) y se elige con un radio,
// como "Relacionar documento".

export function PositionField({
  selected,
  onSelect,
}: {
  selected: Position | null;
  onSelect: (p: Position) => void;
}): ReactElement {
  const searchId = useId();
  const [text, setText] = useState('');
  const term = useDebouncedValue(text.trim(), 250);
  const search = usePositionSearch(term, true);
  const rows = search.data ?? [];

  return (
    <>
      <div className="fld">
        <label htmlFor={searchId} className="fld-lab">
          Buscar puesto
        </label>
        <input
          id={searchId}
          className="selector fw"
          value={text}
          maxLength={120}
          placeholder="Nombre o código del puesto"
          autoComplete="off"
          onChange={(e) => setText(e.target.value)}
        />
      </div>
      {search.isError && (
        <div className="fld-error" role="alert">
          No se pudo cargar el catálogo de puestos del LMS. Intenta de nuevo o asigna a una persona.
          <button
            type="button"
            className="btn mut sm"
            disabled={search.isFetching}
            onClick={() => void search.refetch()}
          >
            Reintentar
          </button>
        </div>
      )}
      {search.data !== undefined && rows.length === 0 && (
        <p className="soft" style={{ margin: 0, fontSize: 13 }}>
          No hay puestos que coincidan.
        </p>
      )}
      {rows.length > 0 && (
        <fieldset className="fld" style={{ border: 0, padding: 0, margin: 0 }}>
          <legend className="fld-lab">Puestos</legend>
          <div className="doc-picker resp-positions">
            {rows.map((p) => (
              <label key={p.id} className="doc-opt">
                <input
                  type="radio"
                  name="responsibility-position"
                  checked={selected?.id === p.id}
                  onChange={() => onSelect(p)}
                />
                {p.name} <span className="code">{p.code}</span>
              </label>
            ))}
          </div>
        </fieldset>
      )}
    </>
  );
}
